import { css } from "../../../component-styles";

/** No typography overrides — inherits from the page's global CSS. */
export const noneFonts: string[] = [];

export const none = css``;
